import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { MdOutlineArrowLeft, MdOutlineLocalPrintshop, MdOutlineFactCheck, MdOutlineSend, MdOutlineTextIncrease, MdOutlineTextDecrease, MdOutlineFileDownload, MdCheckBoxOutlineBlank } from "react-icons/md";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { BsPencil, BsThreeDotsVertical } from "react-icons/bs";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { LuSheet } from "react-icons/lu";

import './css/view.css'

import { AppContext } from "../../Context";
import { Loader, GET, ClassToName, FetchAsync } from "../../inc/Fetch"; 
import Header from "./Header";
import Student_tasks from "./components/Student_tasks";
import Teachers_tasks from "./components/Teachers_tasks";
import Teachers_task_info from "./components/Teachers_task_info";
import Permission from '../Permission'
import Teachers_games from './components/Teachers_games';
import Teachers_games_info from './components/Teachers_games_info';
import { Img } from '../../components/Elements';
import { ClassesDropdown, ImageUpload, Input, UploadForm } from '../../components/Form';

export default function UserInfo({action}) {

    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();

    const { userData, successData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;
    const [open, setopen] = successData;

    const [filter, setfilter] = useState({}); 
    const [data, setdata] = useState({}); 
    const [loading, setloading] = useState(true); 
    const [loader, setloader] = useState(false); 
    const [values, setvalues] = useState({}); 

    async function loadData() {
        let r = await GET(`user/info`);
        
        setvalues(r?.user);
        setloading(false);
    }

    async function submit(e) {
        e.preventDefault();
        setloader(true);

        let res = await FetchAsync(`/user/edit`, values);
        
        if (res?.error) {
            setopen({
                short:t("error",  { returnObjects: true })[res?.error],
                error:true
            });
        } else {
            setopen({
                error:false
            });

            setuserinfo(p => ({
                ...p,
                name: res?.success?.name,
                zehot: res?.success?.zehot,
                classes: res?.success?.classes,
            }));

            if (res?.success?.img?.length) {
                setuserinfo(p => ({
                    ...p,
                    img: res?.success?.img,
                }));
            }
        }
        
        setloader(false);

    }

    useEffect(() => {
        loadData();
    }, []);

    if (loading) {
        return <Loader />
    }
    
    if (!values?._id) {
        return false;
    }



    return (
        <>
            <div className='taskNewBody'>
                
                <Header />
                
                <div className='teacherTaskBox'>
                    
                    <div className='mainWidth shadow' style={{maxWidth:600,}}>
        
                        <nav className='breadcrumbs'>
                            <Link to={`/`}>{t("home")}</Link>
                            <MdOutlineArrowLeft />
                            <Link>{t("header_user_menu_1")}</Link>
                        
                        </nav>
        
                        <div className='mainMyTasksTitleBox'>
                            <h1 className='mainTitle'>{t("header_user_menu_1")}</h1>
                           
                        </div>



        
                        <form onSubmit={submit} className='myTaskBody userinfoBox' style={{padding:0,}}>

                            <div className='studentImg' style={{marginTop:40}}>

                                {/* <UploadForm 
                                    style={{maxWidth:"unset"}}
                                    onChange={(e) => setvalues(p => ({ ...p, img: e }))}
                                    value={values?.img}
                                /> */}

                            </div>

                            <div className='studentInput'>

                                <Input 
                                    validate={true}
                                    title={t("name")}
                                    onChange={(e) => setvalues(p => ({ ...p, name: e }))}
                                    value={values?.name}
                                />

                                <Input 
                                    // validate={true}
                                    title={t("id")}
                                    onChange={(e) => setvalues(p => ({ ...p, zehot: e }))}
                                    value={values?.zehot}
                                />

                                <Input 
                                    validate={true}
                                    title={t("login_username")}
                                    disabled={true}
                                    placeholder={" "}
                                    onChange={(e) => setvalues(p => ({ ...p, user: e }))}
                                    value={values?.user}
                                />

                                <ClassesDropdown
                                    click={userinfo?.userlevel >= 3 ? false : true}
                                    validate={true}
                                    onChange={(e) => setvalues(p => ({ ...p, classes: e }))}
                                    value={values?.classes}
                                />

                                <Input 
                                    validate={true}
                                    disabled={true}
                                    title={t("school")}
                                    placeholder={" "}
                                    // onChange={(e) => setvalues(p => ({ ...p, school: e }))}
                                    value={values?.school?.name}
                                />

                                


                            </div>

                            <div className='studentInput'>

                                <Input 
                                    title={t("user_current_pass")}
                                    onChange={(e) => setvalues(p => ({ ...p, password: e }))}
                                    value={values?.password}
                                    type='password'
                                />

                                <Input 
                                    title={t("user_new_pass")}
                                    onChange={(e) => setvalues(p => ({ ...p, newpass: e }))}
                                    value={values?.newpass}
                                    type='password'
                                />

                                <Input 
                                    title={t("user_new_pass_confirm")}
                                    onChange={(e) => setvalues(p => ({ ...p, newpass2: e }))}
                                    value={values?.newpass2}
                                    type='password'
                                />


                            </div>

                            <div style={{display:"flex", justifyContent:"center", padding:10,}}>
                                <button className='btn'>{t("user_update")}</button>
                            </div>
                        </form>
        
                        
        
                    </div>
        
        
                </div>
        
               
            </div>
        </>
    )
}
